import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";

import { useStyles } from "../../../../../Components/CSS/DetailStyle.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class VehicleDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 20,
      page: 0,
      vehicleDetail: {},
      driverDetail: {},
      assistantDriver: {},
      students: [],
      column: [{ name: "S.N." }, { name: "Full Name" }, { name: "Address" }],
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getVehicleDetail(this.props.match.params.id);
    }
  }

  getVehicleDetail = async (vehicleId) => {
    try {
      const response = await Axios.get(`${url}/api/vehicles/${vehicleId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.vehicle) {
        this.setState({
          vehicleDetail: response.data.vehicle,
          driverDetail: response.data.vehicle.driver,
          assistantDriver: response.data.vehicle.assistantDriver,
          students: response.data.vehicle.students,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getVehicleDetail(vehicleId);
      }
    }
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const {
      vehicleDetail,
      driverDetail,
      assistantDriver,
      students,
      rowsPerPage,
      page,
    } = this.state;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Vehicle Details"
            url={`/administration/vehicle/edit/${this.props.match.params.id}`}
            urlTitle="Edit Vehicle"
            icon={<EditIcon style={{ color: "#1f1f1f" }} />}
          />
          {this.state.vehicleDetail && (
            <div>
              <div className={classes.listitemRoot}>
                <div style={{ width: "50%", marginRight: 10 }}>
                  <ListItem divider>
                    <b style={{ flexGrow: 1 }}>Route:- </b>
                    <div>{vehicleDetail.route}</div>
                  </ListItem>
                  <ListItem divider>
                    <b style={{ flexGrow: 1 }}>Driver:- </b>
                    {driverDetail && (
                      <Tooltip
                        arrow
                        title="See Details"
                        className={classes.tooltip}
                        onClick={() =>
                          this.props.history.push(
                            `/administration/driver/details/${driverDetail._id}`
                          )
                        }
                      >
                        <div>{driverDetail.driverFullName}</div>
                      </Tooltip>
                    )}
                  </ListItem>
                </div>
                <div style={{ width: "50%" }}>
                  <ListItem divider>
                    <b style={{ flexGrow: 1 }}>Vehicle Number:- </b>
                    <div>{vehicleDetail.vehicleNumber}</div>
                  </ListItem>
                  <ListItem divider>
                    <b style={{ flexGrow: 1 }}>Assistant Driver:- </b>
                    {assistantDriver && (
                      <Tooltip
                        arrow
                        title="See Details"
                        className={classes.tooltip}
                        onClick={() =>
                          this.props.history.push(
                            `/administration/driver/details/${assistantDriver._id}`
                          )
                        }
                      >
                        <div>{assistantDriver.driverFullName}</div>
                      </Tooltip>
                    )}
                  </ListItem>
                </div>
              </div>
              <ListItem style={{ display: "flex", alignItems: "center" }}>
                <b style={{ fontSize: 24 }}>Students in Vehicles</b>
                <Tooltip
                  arrow
                  title="Add More Students"
                  className={classes.tooltip}
                >
                  <AddCircleIcon />
                </Tooltip>
              </ListItem>
              {students.length !== 0 && (
                <TableContainer>
                  <Table>
                    <CustomTableHead column={this.state.column} />
                    <TableBody>
                      {students.map((student, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="center">
                            {student.firstName} {student.middleName}{" "}
                            {student.lastName}
                          </TableCell>
                          <TableCell align="center">
                            {student.address.vdc}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>

                    <CustomTableFooter
                      count={students.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={this.handlePage}
                      onChangeRowsPerPage={this.handleRowsPerPage}
                    />
                  </Table>
                </TableContainer>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(VehicleDetails)));
